// src/infrastructure/mapbox/adapters/mapboxMarkerAdapter.tsx

import React from 'react';
import { Marker } from 'react-map-gl';
import { MapMarker } from '../../domain/entities/MapMarker';
import { PropertyMarker } from '../../presentation/components/PropertyMarker';

export function MapboxMarker(
  marker: MapMarker,
  isSelected: boolean,
  onClick?: () => void,
  ref?: any,
  onMouseEnter?: () => void,
  onMouseLeave?: () => void
): JSX.Element {
  try {
    return (
      <Marker
        key={marker.propertyId}
        latitude={marker.lat}
        longitude={marker.lng}
        style={{ zIndex: isSelected ? 1000 : 0 }}
        ref={ref}
        onClick={(e) => {
          e.originalEvent.stopPropagation();
          onClick?.();
        }}
      >
        <div
          className="property-marker-container"
          id={marker.propertyId}
          onMouseEnter={(e) => {
            e.stopPropagation();
            onMouseEnter?.();
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
            onMouseLeave?.();
          }}
        >
          <PropertyMarker
            addressId={marker.propertyId}
            popupInfoId={marker.propertyId}
            popupLoading={false}
            listPrice={marker.listPrice}
            isFavorite={false}
            isMainProperty={false}
            isRental={marker.saleOrRent?.toUpperCase() === 'RENT'}
          />
        </div>
      </Marker>
    );
  } catch (error) {
    console.error('Error mapping marker', error);
    return <></>;
  }
}
